import type { SVGProps } from "react";

export const InProgressLocationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_7758_83890"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="15"
      height="15"
    >
      <rect
        x="1.01426"
        y="1.18516"
        width="12.075"
        height="12.075"
        fill="#D9D9D9"
        stroke="#4D7C0F"
        strokeWidth="1.925"
      />
    </mask>
    <g mask="url(#mask0_7758_83890)">
      <path
        d="M10.3793 10.5502L10.3963 10.5332L10.3793 10.5161L7.0759 7.21277V2.55607V2.53201H7.05184C5.74281 2.53201 4.63318 2.98653 3.72441 3.89531C2.81563 4.80408 2.36111 5.91371 2.36111 7.22274C2.36111 8.53176 2.81563 9.64139 3.72441 10.5502C4.63318 11.4589 5.74281 11.9135 7.05184 11.9135C7.67715 11.9135 8.27815 11.7962 8.85466 11.5617C9.43124 11.3272 9.9395 10.9899 10.3793 10.5502ZM7.05184 13.032C6.24803 13.032 5.49295 12.8795 4.78637 12.5746C4.07933 12.2695 3.46453 11.8556 2.94177 11.3328C2.41901 10.81 2.00507 10.1953 1.69997 9.4882C1.39508 8.78162 1.24257 8.02655 1.24257 7.22274C1.24257 6.41892 1.39508 5.66385 1.69997 4.95727C2.00507 4.25022 2.41901 3.63543 2.94177 3.11267C3.46453 2.58991 4.07933 2.17597 4.78637 1.87087C5.49295 1.56598 6.24803 1.41347 7.05184 1.41347C7.85565 1.41347 8.61073 1.56598 9.31731 1.87087C10.0244 2.17597 10.6391 2.58991 11.1619 3.11267C11.6847 3.63543 12.0986 4.25022 12.4037 4.95727C12.7086 5.66385 12.8611 6.41892 12.8611 7.22274C12.8611 8.02655 12.7086 8.78162 12.4037 9.4882C12.0986 10.1953 11.6847 10.81 11.1619 11.3328C10.6391 11.8556 10.0244 12.2695 9.31731 12.5746C8.61073 12.8795 7.85565 13.032 7.05184 13.032Z"
        fill="white"
        stroke="#454749"
        strokeWidth="0.048125"
      />
    </g>
  </svg>
);
